import { FC, useMemo } from "react";

import clsx from "clsx";

import {
  StyledStep,
  StyledStepper,
  StyledStepButton,
} from "styles/components/stepper";

interface StepperProps {
  stepsCount: number;
  activeStep?: number;
  completed?: {
    [key: number]: boolean;
  };
  nextStepsAreEnabled?: boolean;
  dataTestId?: string;
  className?: string;
  progressBarView?: boolean;

  onStepClick?: (index: number) => void;
}

const Stepper: FC<StepperProps> = ({
  stepsCount,
  activeStep,
  completed,
  nextStepsAreEnabled,
  className,
  dataTestId,
  progressBarView,
  onStepClick,
}) => {
  const stepperClassName = clsx([
    "stepper",
    { stepper_progress: progressBarView },
    className,
  ]);

  const currentActiveStep = useMemo(
    () => (activeStep ? activeStep - 1 : 0),
    [activeStep]
  );

  return (
    <StyledStepper
      activeStep={currentActiveStep}
      className={stepperClassName}
      data-testid={dataTestId}
    >
      {Array(stepsCount)
        .fill(0)
        .map((_, index) => (
          <StyledStep
            key={`step-${index}`}
            completed={completed?.[index]}
            disabled={nextStepsAreEnabled && index !== 0 ? false : undefined}
            data-testid={dataTestId && `${dataTestId}-step`}
          >
            {!progressBarView ? (
              <StyledStepButton
                disableRipple
                onClick={() => onStepClick?.(index + 1)}
                data-testid={dataTestId && `${dataTestId}-step-btn`}
              />
            ) : null}
          </StyledStep>
        ))}
    </StyledStepper>
  );
};

export default Stepper;
